import React from "react";
import { FiCalendar } from "react-icons/fi";

const TDSInfoTab = ({ selectedClientData, getStatusColor }) => {

    console.log("selectedClientData?.tdsDetails", selectedClientData?.tdsDetails);
    
    return (
        <div className="space-y-6">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">TDS Information</h3>
                {selectedClientData?.tdsDetails ?
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4">TDS Information</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">TAN</label>
                            <p className="text-sm text-gray-900">{selectedClientData?.tdsDetails?.tan || 'Not Available'}</p>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Authorized Signatory</label>
                            <p className="text-sm text-gray-900">{selectedClientData?.tdsDetails?.authorizedSignatory}</p>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Signatory PAN</label>
                            <p className="text-sm text-gray-900">{selectedClientData?.tdsDetails?.signatoryPAN}</p>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Signatory Mobile</label>
                            <p className="text-sm text-gray-900">{selectedClientData?.tdsDetails?.signatoryMobile}</p>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Signatory Email</label>
                            <p className="text-sm text-gray-900">{selectedClientData?.tdsDetails?.signatoryEmail}</p>
                        </div>
                    </div>

                    {/* TDS Deductions */}
                    {selectedClientData?.tdsDetails?.deductions?.length > 0 && (
                        <div>
                            <h4 className="text-md font-semibold text-gray-900 mb-3">TDS Deductions</h4>
                            <div className="overflow-x-auto">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                        <tr>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Deductee</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nature of Payment</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Section</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount Paid</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">TDS Deducted</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {selectedClientData?.tdsDetails?.deductions?.map((deduction) => (
                                            <tr key={deduction.id} className="hover:bg-gray-50">
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div>
                                                        <div className="text-sm font-medium text-gray-900">{deduction.deducteeName}</div>
                                                        <div className="text-sm text-gray-500">PAN: {deduction.deducteePAN}</div>
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{deduction.natureOfPayment}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{deduction.section}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">₹{deduction.amountPaid.toLocaleString()}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">₹{deduction.tdsDeducted.toLocaleString()}</td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(deduction.status)}`}>
                                                        {deduction.status}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div> : 
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 text-center">
                    <FiCalendar className="h-12 w-12 text-gray-500 mx-auto mb-4" />
                    <h3 className="text-lg font-medium text-gray-900 mb-2">
                        No TDS Information
                    </h3>
                    <p className="text-gray-600 mb-4">
                        This client doesn't have any TDS Information yet.
                    </p>
                </div>}
            </div>
        </div>
    );
};

export default TDSInfoTab;